import {OmnichannelFixedGapType} from '@/interfaces/server-data';

export class FixedDiffParams {
  type!: OmnichannelFixedGapType;
  gap!: number;
  applyForPriceSegments!: boolean;
  applyCompetitorPrices!: boolean;
  applyMinProfitabilityLimit!: boolean;

  // Need for jackson polymorphism
  // noinspection JSUnusedGlobalSymbols
  typeJson: string = 'fixedDiff';

  constructor(
    type: OmnichannelFixedGapType,
    gap: number,
    applyForPriceSegments: boolean,
    applyCompetitorPrices: boolean,
    applyMinProfitabilityLimit: boolean,
  ) {
    this.type = type;
    this.gap = gap;
    this.applyForPriceSegments = applyForPriceSegments;
    this.applyCompetitorPrices = applyCompetitorPrices
    this.applyMinProfitabilityLimit = applyMinProfitabilityLimit
  }

}

export interface IStrategyParamsDto {
  type: OmnichannelFixedGapType | null;
  gap: number | null;
  applyForPriceSegments: boolean | null;
  applyCompetitorPrices: boolean | null;
  applyMinProfitabilityLimit: boolean | null;
  bottomEdge: number | null;
  topEdge: number | null;
  depth: number | null;
}
